<table  datatable [dtOptions]="dtOptions" class="table table-striped display compact" *ngIf="messagesReceived.length>0">
    <thead>
    <tr>
    <th>Date</th>
    <th>From</th>
    <th>Subject</th>
    <th>Read</th>
    </tr>
    </thead>
    
    <tbody>
    <tr *ngFor="let message of messagesReceived;">
        <td></td>
        <td></td>
        <td></td>
    </tr>
    </tbody>
     
</table>
<div class="alert alert-info" *ngIf="messagesReceived.length <= 0">
    No Messages Found
</div>
